<template>
  <el-tooltip :content="stateLabel" placement="top" :open-delay="300">
    <i v-if="state === STATE_CODE.DANG_THUC_HIEN"
       class="far fa-play-circle color__yellow icon-status font-size__large"
    ></i>

    <i v-if="state === STATE_CODE.CHO_PHE_DUYET_HOAN_THANH"
       class="far fa-clock color__blue icon-status font-size__large"
    ></i>

    <i v-if="state === STATE_CODE.HOAN_THANH"
       class="fas fa-check-circle color__green icon-status font-size__large"
    ></i>

    <i v-if="state === STATE_CODE.HUY_CHI_DAO"
       class="far fa-times-circle color__red icon-status font-size__large"
    ></i>

    <i v-if="state === STATE_CODE.TRUNG_CHI_DAO"
       class="fas fa-exclamation color__red icon-status font-size__large"
    ></i>
  </el-tooltip>
</template>

<script>
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import constants from "../../../constants";

export default {
  name: "hc-quychequydinh-state-icon",
  props: ["state"],
  data() {
    return {
      STATE_CODE: constants.HC_STATE.STATE_CODE.QUY_CHE_QUY_DINH
    }
  },

  computed: {
    stateLabel() {
      return hanhChinhUtils.getQuyCheQuyDinhStateName(this.state);
    }
  },

  methods: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/quychequydinh/hc-quychequydinh-state-icon.vue